import { infoCardGeneratorAsync } from 'services/infoCardGenerator';

import { propel } from 'services/infoCardGenerator/aai/pcomm_router';

/**
 * client side cache; useful for when users leave chat and re-open it on the same page.
 */
const urlMetadataMemo: {
  [x: string]: propel.core.MessageExtension.IInformation | null | undefined;
} = {};

const getPageMetadata = async (url: string) => {
  if (!url) return null;

  if (urlMetadataMemo[url]) return urlMetadataMemo[url];

  const result = await infoCardGeneratorAsync(url);
  urlMetadataMemo[url] = result;
  return result;
};

export { getPageMetadata };
